import SparkMD5 from 'spark-md5';

export function md5(content) {
    // Ensure content is a string
    return SparkMD5.hash(String(content || ""));
}
